export enum PassReservationPriceTypeEnum {
    FULL = 'F',
    REDUCED = 'R',
}
